var UIRouterPluginBase = /** @class */ (function () {
    function UIRouterPluginBase() {
    }
    UIRouterPluginBase.prototype.dispose = function (router) { };
    return UIRouterPluginBase;
}());
export { UIRouterPluginBase };
//# sourceMappingURL=interface.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@uirouter/core/lib-esm/interface.js
// module id = 278
// module chunks = 1